import MDBox from "../../../components/MDBox";
import Grid from "@mui/material/Grid";
import MasterCard from "../../../examples/Cards/MasterCard";
import LocalStorage from "../../../utils/LocalStorage";
import DefaultInfoCard from "../../../examples/Cards/InfoCards/DefaultInfoCard";
import PaymentMethod from "../../billing/components/PaymentMethod";
import Invoices from "../../billing/components/Invoices";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import Footer from "../../../examples/Footer";
import PaymentLinkStripe from "./PaymentLinkStripe";
import MDTypography from "../../../components/MDTypography";
import {Alert} from "@mui/material";
import React from "react";

const PaymentPage = () => {
    return (

                <MDBox mb={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} >
                            <Grid container>
                                <Grid item xs={12}>
                                    <PaymentLinkStripe />
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </MDBox>

           )
}

export default PaymentPage